(() => {
  function rotateRecommendations(section) {
    if (section.hasAttribute('data-rotation-ready')) return true;

    const grid = section.querySelector('.product-grid');
    if (!grid) return false;

    const cards = Array.from(grid.children).filter((card) => card.classList.contains('grid__item'));
    if (!cards.length) return false;

    const visibleCount = Math.min(10, Math.max(1, Number(section.dataset.visibleCount) || 4));
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }

    grid.replaceChildren(...cards.slice(0, visibleCount));
    section.setAttribute('data-rotation-ready', 'true');
    return true;
  }

  function watchRecommendations(section) {
    if (rotateRecommendations(section)) return;

    const observer = new MutationObserver(() => {
      if (rotateRecommendations(section) || section.classList.contains('product-recommendations--loaded')) {
        observer.disconnect();
      }
    });
    observer.observe(section, { childList: true });
  }

  function initializeRecommendations(root = document) {
    root.querySelectorAll('product-recommendations.related-products[data-rotate-products]').forEach(watchRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeRecommendations(), { once: true });
  } else {
    initializeRecommendations();
  }

  document.addEventListener('shopify:section:load', (event) => initializeRecommendations(event.target));
})();
